import axios from "./axios";

export async function fetchUsers(controller) {
  let { filters, sort, sortBy, page, query, view, per_page, fields, active, showInDropdown } = controller;

  const params = {
    query: query,
    page: page,
    per_page: per_page,
    sortBy: sortBy,
    sort: sort,
    filters: filters,
    view: view,
    fields: fields,
    active: active,
    showInDropdown: showInDropdown,
  };

  return axios({ method: "get", url: "/users/", params: params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchUser(id, params = {}) {
  return axios({ method: "get", url: `/users/${id}`, params: params })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // Preserve Axios error shape for callers that read err.data.errors.
      return Promise.reject(error);
    });
}

/**
 * All assignable roles for company user UI. The /users/roles endpoint is paginated
 * (default per_page 25); without a large per_page, older roles (e.g. "calendar") can be missing.
 */
export async function fetchRoles(params = {}) {
  try {
    const metaRes = await axios({
      method: "get",
      url: `/users/roles`,
      params: { per_page: 1, page: 1, ...params },
    });
    const total = Number(metaRes?.data?.totalCount) || 0;
    const perPage = Math.min(Math.max(total, 1), 5000);
    return await axios({
      method: "get",
      url: `/users/roles`,
      params: { per_page: perPage, page: 1, ...params },
    });
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * System (built-in) role templates for onboarding new employees.
 * Returns { data: [{ id, label, description, roles: string[], projects_scope }] }.
 */
export async function fetchRoleTemplates() {
  return axios({ method: "get", url: `/users/role_templates` })
    .then((response) => response?.data?.data || [])
    .catch(() => []);
}
